export default {
    state: {
        modalComponent: null,
        modalProps: null
    },
    mutations: {
        modal(state, {componentName, componentProps}) {
            state.modalComponent = componentName;
            state.modalProps = componentProps;
        }
    },
    actions: {
        openModal({commit}, component) {
            commit('modal', component);
        },
        closeModal({commit}) {
            commit('modal', {
                componentName: null,
                componentProps: null
            });
        }
    }
};